var fn_masthead = function () {
    // begin masthead video //
    // Video paused when out of viewport
    // See: http://morr.github.io/appear.html
    // ON: Appear
    var appearVideo = function (e, elt) {
        var video = $(elt).get(0)
        var $videoBtn = $(this).parents('.data-is-video-wrapper').siblings('.btn-has-video')

        if (video.paused && $(elt).data('status') === 'playing') {
            $(elt).get(0).play()
            $videoBtn.children('span').toggleClass('ikon-pause-disc ikon-play-disc')
        }
    }
    // OFF: Disappear
    var disappearVideo = function (e, elt) {
        var video = $(elt).get(0)
        var $videoBtn = $(this).parents('.btn-is-video-wrapper').siblings('.btn-has-video')

        if (!video.paused) {
            video.pause()
            $videoBtn.children('span').toggleClass('ikon-play-disc ikon-pause-disc')
        }
    }
    // Masthead - SPLASH VIDEO
    // > class ".desktop" to activate video injection only (from data-video)
    // desktop browser
    $('.desktop .masthead-has-video').each(function () {
        var header = $(this),
            videoPath = header.data('video'),
            covervid = $('<div class="data-is-video-wrapper animated fader"><video class="data-is-video" muted autoplay loop data-object-fit="cover" data-status="playing"  poster="' + videoPath + '.jpg" aria-hidden="true" tabindex="-1"><source src="' + videoPath + '.mp4" type="video/mp4"></video></div> <div class="btn-is-video-wrapper"><button type="button" class="btn btn-has-video" aria-label="Mettre en pause la vidéo"><span class="ikon-pause-disc" aria-hidden="true"></span></button></div>')

        //
        covervid.find('video').on('canplay', function () {
            covervid.addClass('fadeIn').removeClass('fader')
            header.find('.fader').addClass('animated fadeInUpHeader').removeClass('fader')
        })
        $(this).append(covervid).find('video').appear()
        $(this).find('video').on('appear', appearVideo).on('disappear', disappearVideo)
    })
    // > class ".mobile or tablet" to activate bg injection only (from data-cover)
    // mobile browser 
    $('.mobile .masthead-has-video, .tablet .masthead-has-video').each(function () {
        var header = $(this),
            coverPath = header.data('cover');
        
        //
        header.css("background-image","url('"+coverPath+"')");
    })

    $('.mobile .masthead-has-video .fader, .tablet .masthead-has-video .fader').addClass('animated fadeInUpHeader').removeClass('fader')

    $(window).on('load', function () {
        
        // Is in viewport detection - see Masthead JS + Covervid JS
        // > Pause video when out of viewport
        // See: https://github.com/zeusdeux/isInViewport
        // --> Conflict with jquery no conflict so we change for another lib - see below jquery.appear
        // See: https://github.com/morr/jquery.appear
        //
        // Other wise check out: https://www.npmjs.com/package/video-in-view
        //
        $('video').appear().on('appear', appearVideo).on('disappear', disappearVideo)

        // Splash Video button play / pause
        $('.masthead-has-video .btn-has-video').on('click', function () {
            var video = $('.data-is-video-wrapper video'),
                videoElement = video.get(0),
                status = 'pause';

            if (videoElement.paused) {
                status = 'play';
                // TO DO : Passer le texte JS dans un data HTML
                $('.masthead-has-video .btn-has-video').attr('aria-label', 'Mettre en pause la vidéo');
                $('.masthead-has-video .btn-has-video span').addClass('ikon-pause-disc').removeClass('ikon-play-disc');
            } else {
                $('.masthead-has-video .btn-has-video').attr('aria-label', 'Lancer la vidéo');
                $('.masthead-has-video .btn-has-video span').addClass('ikon-play-disc').removeClass('ikon-pause-disc');
            }
            video.trigger(status);
        })

    })
    // end masthead video //
}